import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { AuthForm } from "@/components/AuthForm";

type Mode = "sign-in" | "sign-up" | "forgot-password";

export function SignInPage() {
  const { firebaseConfigured } = useAuth();
  const [mode, setMode] = useState<Mode>("sign-in");

  if (!firebaseConfigured) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-stone-100 px-4">
        <div className="w-full max-w-sm rounded-3xl border border-stone-200 bg-white p-10 shadow-sm text-center">
          <p className="font-serif text-2xl text-stone-900 mb-4">Setup required</p>
          <p className="text-sm text-stone-500 leading-relaxed">
            Firebase authentication is not yet configured. Add the{" "}
            <code className="rounded bg-stone-100 px-1 py-0.5 text-xs">VITE_FIREBASE_*</code>{" "}
            environment variables and restart the app.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-stone-100 px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-stone-900 text-white text-2xl font-bold">
            →
          </div>
          <h1 className="font-serif text-3xl text-stone-900">QuotedsArrow</h1>
          <p className="mt-1 text-sm text-stone-500">Words with Pointed Purpose</p>
        </div>

        <div className="rounded-3xl border border-stone-200 bg-white p-8 shadow-sm">
          <h2 className="mb-6 text-center text-lg font-semibold text-stone-900">
            {mode === "sign-in" ? "Welcome back" : "Create your account"}
          </h2>
          <AuthForm initialMode={mode} onModeChange={setMode} />
        </div>
      </div>
    </div>
  );
}
